// extracted by mini-css-extract-plugin
module.exports = {"navBack":"NavBack_navBack__CqVT5","customLink":"NavBack_customLink__aS2Am","arrow":"NavBack_arrow__3eq9u","left":"NavBack_left__YQ9Rn","customMargin":"NavBack_customMargin__2iDd2"};